import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MarkdownModule } from 'ngx-markdown';

import { AdminAlertLevel } from '../../types';

@Component({
  selector: 'app-admin-alert',
  templateUrl: './admin-alert.component.html',
  styleUrls: ['./admin-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MarkdownModule, MatIconModule],
})
export class AdminAlertComponent {
  @Input() message = '';
  @Input() level: AdminAlertLevel = 'default';
  @Input() isClosable = true;

  @Output() dismiss: EventEmitter<void> = new EventEmitter<void>();

  onClose(): void {
    this.dismiss.emit();
  }
}
